import React, { FC } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const snackbarMessage = `We don't currently have coverage for that area, register your interest and we will let you know when we can cover that postcode.`

const NoCoverageMessage: FC<React.PropsWithChildren<unknown>> = ({
  
}) => {
  return (
    <Box>
      <Typography gutterBottom>
        We don't currently have coverage for that area, register your interest and we will let you know when we can cover that postcode.
      </Typography>
    </Box>
  )
}

export default NoCoverageMessage